import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/clock.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V11.3818L16.4473 13.1055L16.5361 13.1562C16.9643 13.4276 17.1261 13.9842 16.8945 14.4473C16.663 14.9104 16.1204 15.1153 15.6465 14.9355L15.5527 14.8945L11.5527 12.8945C11.214 12.7251 11 12.3788 11 12V6ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ClockIcon };
